/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AppendContactListRequest
 */
export interface AppendContactListRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof AppendContactListRequest
   */
  contactIds?: Array<string>
}

export function AppendContactListRequestFromJSON(json: any): AppendContactListRequest {
  return AppendContactListRequestFromJSONTyped(json, false)
}

export function AppendContactListRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppendContactListRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactIds: !exists(json, 'contact_ids') ? undefined : json['contact_ids']
  }
}

export function AppendContactListRequestToJSON(value?: AppendContactListRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_ids: value.contactIds
  }
}
